import { addMinutes, isAfter, isBefore, parseISO } from "date-fns";

import { StatusType, TourType } from "@/types";

export function tourStatus(
  tour: TourType,
  earlyAccessAmount: number
): StatusType {
  if (tour.deletedAt) {
    return "deleted";
  } else if (
    tour.scheduledStart &&
    tour.scheduledEnd &&
    earlyAccessAmount &&
    isAfter(
      new Date(),
      addMinutes(parseISO(tour.scheduledStart), earlyAccessAmount * -1)
    ) &&
    isBefore(new Date(), parseISO(tour.scheduledEnd))
  ) {
    return "active";
  } else if (
    tour.scheduledStart &&
    tour.scheduledEnd &&
    isAfter(new Date(), parseISO(tour.scheduledStart)) &&
    isBefore(new Date(), parseISO(tour.scheduledEnd))
  ) {
    return "active";
  } else if (
    tour.scheduledEnd &&
    isAfter(new Date(), parseISO(tour.scheduledEnd))
  ) {
    return "expired";
  }

  return "pending";
}
